<template>
  <Tabbar
    v-if="isMobile"
    :model-value="active"
    fixed
    placeholder
    safe-area-inset-bottom
    active-color="#EE0A24"
    inactive-color="#969799"
    class="app-tabbar"
  >
    <TabbarItem name="payment" icon="credit-pay" @click="goPayment">
      {{ t('tabbar.recharge') }}
    </TabbarItem>
    <TabbarItem name="mall" icon="shop-o" @click="goMall">
      {{ t('tabbar.pointsMall') }}
    </TabbarItem>
  </Tabbar>
</template>

<script setup>
import { computed } from 'vue'
import { Tabbar, TabbarItem } from 'vant'
import { useI18n } from 'vue-i18n'
import { isMobile } from '@/utils'

const { locale, t } = useI18n()

const active = 'payment'

const MALL_BASE_URL = process.env.VUE_APP_MALL_URL

const mallUrl = computed(() => `${MALL_BASE_URL}/${locale.value}`)

const goPayment = () => {
  // 当前已在充值中心，无需跳转
}

const goMall = () => {
  window.location.href = mallUrl.value
}
</script>

<style scoped lang="less">
.app-tabbar {
  z-index: 200;
}
</style>
